var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessedMeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#325CA7;}\n\t.st1{fill:#B9CFC0;}\n\t.st2{fill:#FFF8CF;}\n\t.st3{fill:#AD5231;}\n\t.st4{fill:#9C5E2E;}\n\t.st5{fill:#233236;}\n\t.st6{fill:#EEEDED;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,149.93,61.17,184.22,103.86,184.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.97,70.35c0-0.13-0.02-0.25-0.05-0.36c-0.63-6.66-18.43-10.14-36.03-10.14c-17.6,0-35.4,3.48-36.03,10.14 c-0.03,0.12-0.05,0.24-0.05,0.36v69.47c0,0.11,0.02,0.22,0.04,0.33c0.39,8.58,16.07,15.25,36.04,15.25 c19.96,0,35.65-6.67,36.04-15.25c0.02-0.11,0.04-0.21,0.04-0.33V70.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.69,70.17c0-5.93,14.02-10.32,36.17-10.32c22.15,0,36.17,5.03,36.17,10.32 c-6.77,2.78-19.49,5.22-36.17,5.22C87.18,75.39,74.46,72.95,67.69,70.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.85,140.31c-2.38-0.08-4.67-0.59-6.81-1.52c-3.13-1.36-5.65-3.37-7.5-5.98 c-2.47-3.49-3.43-7.03-2.93-10.82c0.18-1.41,0.63-2.87,1.4-4.59c2.46-5.49,2.55-9.61,2.63-12.92c0.05-2.3,0.09-4.12,0.88-5.78 c1.09-2.25,2.74-3.8,5.04-4.74c2.17-0.88,4.39-0.97,6.61-0.27c7.27,2.47,16.63,13.29,18.9,21.84c0.75,2.84,1.14,5.3,1.11,7.1 c-0.03,1.93-0.39,3.83-1.07,5.66c-0.89,2.38-2.26,4.52-4.06,6.36c-1.98,2.01-4.34,3.53-7.04,4.51 C98.7,140.01,96.3,140.39,93.85,140.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.96,114.75c-0.17,2.76-2.24,4.78-5.54,5.4c-4.11,0.77-7.2,3.64-10.77,6.96 c-2.35,2.19-5.03,4.67-8.46,6.98c1.18-1.55,2.12-3.26,2.81-5.09c0.76-2.04,1.17-4.17,1.2-6.33c0.03-2.02-0.36-4.59-1.18-7.65 c-1.98-7.48-9.7-17.9-17.57-22.08c4.67,0.14,11.03,0.92,17.24,3.56c6.75,2.87,9.62,5.75,11.93,8.06c1.86,1.87,3.47,3.48,6.39,4.4 C134.5,109.75,136.12,112.13,135.96,114.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.31,120.88c-0.4-1.75-1.46-3.24-2.98-4.19c-1.51-0.94-3.29-1.23-5.02-0.83 c-3.55,0.83-5.76,4.43-4.92,8.01c0.72,3.07,3.46,5.15,6.48,5.15c0.5,0,1-0.06,1.5-0.17C99.85,128.05,102.12,124.39,101.31,120.88 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M95.91,126.88c-2.48,0.58-4.97-0.98-5.55-3.47c-0.58-2.5,0.95-5.01,3.41-5.58c0.35-0.08,0.71-0.12,1.06-0.12 c0.85,0,1.69,0.24,2.43,0.7c1.06,0.66,1.8,1.7,2.08,2.92C99.9,123.78,98.33,126.32,95.91,126.88z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessedMeat);
export default __webpack_public_path__ + "static/media/Processed_meat.f9e887995fdad992c597cf268a6adc34.svg";
export { ForwardRef as ReactComponent };